import { createContext } from "react";
export const UserContext = createContext({
  featureFlags: {
    mentions: false,
  },
});
export const EventInfo = createContext({});
export const ModalInfo = createContext({});
